export const UserType = {
  SuperAdmin: "Super Admin",
  Admin: "Admin",
  Doctor: "Doctor",
  Patient: "Patient",
};
